import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, clearToken, verifyToken } from "../lib/adminAuth";
import PanelDashboard from "../panel/PanelDashboard";
import PanelEntradas from "../panel/PanelEntradas";
import PanelComentarios from "../panel/PanelComentarios";
import PanelSuscriptores from "../panel/PanelSuscriptores";
import PanelPerfil from "../panel/PanelPerfil";

const TABS = [
  { id: "dashboard", label: "Dashboard" },
  { id: "entradas", label: "Entradas" },
  { id: "comentarios", label: "Comentarios" },
  { id: "suscriptores", label: "Suscriptores" },
  { id: "perfil", label: "Perfil" },
];

export default function Panel() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [tab, setTab] = useState("dashboard");
  const [pending, setPending] = useState(0);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Verify token on mount; if invalid, silently redirect to home
  useEffect(() => {
    verifyToken().then((ok) => {
      if (!ok) navigate("/", { replace: true });
      else setReady(true);
    });
  }, [navigate]);

  // Refresh pending comment badge
  const refreshPending = () =>
    adminApi
      .get("/admin/comentarios", { params: { estado: "pendiente", per_page: 1 } })
      .then((r) => setPending(r.data.counts?.pendientes || 0))
      .catch(() => {});

  useEffect(() => {
    if (ready) refreshPending();
  }, [ready, tab]);

  const logout = () => {
    clearToken();
    navigate("/", { replace: true });
  };

  if (!ready) return null;

  return (
    <div className="panel-shell" data-testid="panel-shell">
      <button
        className="panel-mobile-toggle"
        onClick={() => setMobileOpen((v) => !v)}
        data-testid="panel-mobile-toggle"
      >
        {mobileOpen ? "✕" : "☰"} Menú
      </button>
      <aside className={`panel-sidebar ${mobileOpen ? "open" : ""}`}>
        <span className="logo">
          Berenice <span className="accent">Sin Filtro</span>
        </span>
        {TABS.map((t) => (
          <button
            key={t.id}
            className={`panel-tab ${tab === t.id ? "active" : ""}`}
            onClick={() => {
              setTab(t.id);
              setMobileOpen(false);
            }}
            data-testid={`panel-tab-${t.id}`}
          >
            <span>{t.label}</span>
            {t.id === "comentarios" && pending > 0 && (
              <span className="badge" data-testid="panel-badge-pendientes">{pending}</span>
            )}
          </button>
        ))}
        <div className="panel-spacer" />
        <button className="panel-logout" onClick={logout} data-testid="panel-logout">
          Cerrar sesión
        </button>
      </aside>

      <main className="panel-content">
        {tab === "dashboard" && <PanelDashboard onJumpTo={setTab} />}
        {tab === "entradas" && <PanelEntradas />}
        {tab === "comentarios" && <PanelComentarios onChange={refreshPending} />}
        {tab === "suscriptores" && <PanelSuscriptores />}
        {tab === "perfil" && <PanelPerfil />}
      </main>
    </div>
  );
}
